import { render, staticRenderFns } from "./recibo-pagamento-escola-esca-proforma.vue?vue&type=template&id=ce3bae32&scoped=true&"
import script from "./recibo-pagamento-escola-esca-proforma.vue?vue&type=script&lang=js&"
export * from "./recibo-pagamento-escola-esca-proforma.vue?vue&type=script&lang=js&"
import style0 from "./recibo-pagamento-escola-esca-proforma.vue?vue&type=style&index=0&id=ce3bae32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce3bae32",
  null
  
)

export default component.exports